
export enum EnumTipoEPI {
  Solicitacao = 'Solicitacao',
  Confirmacao = 'Confirmacao',
}
